module.exports = __webpack_public_path__ + "static/media/hojeng-ios-qr-code.3daa45c9.svg";